import React from "react";
import PropTypes from "prop-types";
import { cn } from '../../utils/lib/utils';

const Textarea = React.forwardRef(function Textarea(
  { className, ...props },
  ref
) {
  return (
    <textarea
      className={cn(
        "flex min-h-[80px] w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white placeholder-slate-500 focus-visible-none focus-visible-2 focus-visible-slate-400 focus-visible-offset-2 disabled-not-allowed disabled-50",
        className
      )}
      ref={ref}
      {...props}
    />
  );
});

Textarea.propTypes = {
  className: PropTypes.string,
};

Textarea.displayName = "Textarea";

export { Textarea };
